import type { ModuleCode } from '../types'

export const CZECH_CITIES = [
  'Praha',
  'Brno',
  'Ostrava',
  'Plzeň',
  'Liberec',
  'Olomouc',
  'České Budějovice',
  'Hradec Králové',
  'Ústí nad Labem',
  'Pardubice',
  'Zlín',
  'Havířov',
  'Kladno',
  'Most',
  'Opava',
  'Frýdek-Místek',
  'Karviná',
  'Jihlava',
  'Teplice',
  'Děčín',
  'Karlovy Vary',
  'Mladá Boleslav',
  'Bohumín',
  'Třinec',
  'Tábor',
  'Chomutov',
] as const

export const RESTAURANT_NAME_PREFIXES = [
  'U',
  'Hospoda',
  'Restaurace',
  'Pizzerie',
  'Bistro',
  'Café',
  'Bar',
  'Hotel',
  'Pivnice',
  'Vinárna',
] as const

export const RESTAURANT_NAME_SUFFIXES = [
  'U Tří lvů',
  'Modrá Sova',
  'Stará pošta',
  'Pod Lipou',
  'Černý kohout',
  'Zlatá růže',
  'Hvězda',
  'Rybnik',
  'Na Rohu',
  'Pekařova',
  'Nostalgie',
  'Větrník',
  'Pošta',
  'U Vodopádu',
  'Vavřinec',
  'Stříbrná podkova',
  'Šťastný čaj',
  'Tichá pohoda',
  'Korunní princ',
  'Lví srdce',
] as const

export const FIRST_NAMES_CZ = [
  'Jakub',
  'Tereza',
  'Petr',
  'Anna',
  'Tomáš',
  'Karolína',
  'Jan',
  'Markéta',
  'Adam',
  'Lucie',
  'Filip',
  'Eliška',
  'Ondřej',
  'Klára',
  'Lukáš',
  'Veronika',
] as const

export const LAST_NAMES_CZ = [
  'Novák',
  'Svoboda',
  'Černý',
  'Procházka',
  'Kučera',
  'Veselý',
  'Horák',
  'Pokorný',
  'Marek',
  'Kratochvíl',
  'Růžička',
  'Polák',
] as const

export const INCIDENT_TITLES_CZ: Array<{
  title: string
  category: 'payment' | 'sync' | 'hardware' | 'training' | 'connectivity' | 'other'
}> = [
  { title: 'Pokladna nereaguje', category: 'hardware' },
  { title: 'Karetní terminál odmítá transakce', category: 'payment' },
  { title: 'Tiskárna účtenek neoznačuje řádky', category: 'hardware' },
  { title: 'eShop neaktualizuje skladovou dostupnost', category: 'sync' },
  { title: 'Wolt napárování neprošlo', category: 'sync' },
  { title: 'eKiosk se restartuje', category: 'hardware' },
  { title: 'eShop POS sync prodleva', category: 'sync' },
  { title: 'Internet pomalý, KDS lagy', category: 'connectivity' },
  { title: 'Nový kuchař nezná rozhraní KDS', category: 'training' },
  { title: 'Karetní platby přes Apple Pay', category: 'payment' },
  { title: 'Rezervace nepřišla na pokladnu', category: 'sync' },
  { title: 'Tiskárna v baru nedoplňuje papír', category: 'hardware' },
  { title: 'Nové menu se nepropíše na eShop', category: 'sync' },
  { title: 'eRide dispatch nezpočítá trasu', category: 'other' },
]

export const TEAMS_FIXTURE = [
  { id: 'sales', nameCz: 'Obchod', nameEn: 'Sales', members: 6 },
  { id: 'support', nameCz: 'Podpora', nameEn: 'Support', members: 8 },
  { id: 'onboarding', nameCz: 'Onboarding', nameEn: 'Onboarding', members: 4 },
  { id: 'dev', nameCz: 'Vývoj', nameEn: 'Engineering', members: 9 },
  { id: 'field', nameCz: 'Terén', nameEn: 'Field ops', members: 5 },
] as const

export const MODULE_DISTRIBUTION: Array<readonly [ModuleCode, number]> = [
  ['POS', 0.78],
  ['ESHOP', 0.41],
  ['QR', 0.32],
  ['ECONNECT', 0.27],
  ['DISPLAY', 0.22],
  ['ECALL', 0.18],
  ['EKIOSK', 0.12],
  ['ERIDE', 0.09],
  ['ESTOCK', 0.46],
]

export const MODULE_AVG_PRICE_CZK: Record<ModuleCode, number> = {
  POS: 1840,
  ESHOP: 1340,
  ECONNECT: 1140,
  DISPLAY: 740,
  ERIDE: 1340,
  EKIOSK: 740,
  QR: 540,
  ECALL: 940,
  ESTOCK: 640,
}

export const COSTS_BREAKDOWN_KEYS = [
  { key: 'personal', labelKey: 'sales.costsCategory.personal', share: 0.62 },
  { key: 'infra', labelKey: 'sales.costsCategory.infra', share: 0.1 },
  { key: 'marketing', labelKey: 'sales.costsCategory.marketing', share: 0.09 },
  { key: 'hardware', labelKey: 'sales.costsCategory.hardware', share: 0.07 },
  { key: 'support', labelKey: 'sales.costsCategory.support', share: 0.08 },
  { key: 'other', labelKey: 'sales.costsCategory.other', share: 0.04 },
] as const

export const HOURLY_INTENSITY = [
  0.05, 0.04, 0.04, 0.05, 0.08, 0.12, 0.25, 0.45, 0.6, 0.65, 0.7, 0.85, 1.0, 0.9, 0.7, 0.7, 0.75,
  0.85, 0.95, 1.0, 0.85, 0.6, 0.4, 0.2,
] as const

export const DOW_MULTIPLIER = [0.85, 0.7, 0.9, 0.95, 1.0, 1.15, 1.2] as const

export function intensity(date: Date): number {
  const h = date.getHours()
  const dow = date.getDay()
  return HOURLY_INTENSITY[h] * DOW_MULTIPLIER[dow]
}
